import { Col, Divider, Row } from 'antd';
import { cloneDeep, maxBy } from 'es-toolkit';
import { useState } from 'react';
import Button from '../../../../../components/Buttons/Button';
import AddProductFullModal from '../../../../common/AddProductFull/AddProductFullModal';
import LADClaimsItemCard from '../../Edit/Items/LADClaimsItemCard';

const CreateLADItems = ({ items, setItems }) => {
  const [addProductModal, setAddProductModal] = useState(false);
  const [addProductModalIndex, setAddProductModalIndex] = useState(false);

  const setEditMode = (index, val) => {
    const itemsLocal = cloneDeep(items);
    itemsLocal[index].editMode = val;
    setItems(itemsLocal);
  };

  const handleAddNew = () => () => {
    let itemsLocal = cloneDeep(items);
    let nextSequence = maxBy(itemsLocal, ({ itemSeq }) => Number(itemSeq));
    nextSequence = nextSequence ? nextSequence.itemSeq : 0;
    itemsLocal = [
      {
        claimKey: 0,
        itemSeq: nextSequence + 1,
        smAmount: undefined,
        dirtyFlag: 'i',
        isNew: true,
        editMode: true,
      },
      ...itemsLocal,
    ];
    setItems(itemsLocal);
  };

  const handleCancel = (index, isNew) => () => {
    const itemsLocal = cloneDeep(items);
    if (isNew) {
      itemsLocal.splice(index, 1);
    } else {
      itemsLocal[index] = {
        ...itemsLocal[index],
        editMode: false,
      };
    }
    setItems(itemsLocal);
  };

  const handleSubmit = (data, index) => {
    const itemsL = cloneDeep(items);
    itemsL[index] = {
      ...data,
      dirtyFlag: 'i',
      editMode: false,
      isNew: false,
    };
    setItems(itemsL);
  };

  const handleDelete = (index) => () => {
    const itemsL = cloneDeep(items);
    itemsL.splice(index, 1);
    setItems(itemsL);
  };

  const handleNewProductModal = (index) => {
    setAddProductModalIndex(index);
    setAddProductModal(true);
  };

  const onSelectAddressBook = (data) => {
    const itemsLocal = cloneDeep(items);
    itemsLocal[addProductModalIndex] = {
      ...itemsLocal[addProductModalIndex],
      itemCode: data.productCode,
      itemDesc: data.productDesc,
      isNew: true,
      editMode: true,
      itemUnitWeight: data.productWeight,
      itemUnitMeasure: data.productUnitMeasure,
      fullRelFlag: data.fullRelFlag,
    };
    setItems(itemsLocal);
    handleAddProductModalClose();
  };

  const handleAddProductModalClose = () => {
    setAddProductModal(false);
    setAddProductModalIndex(false);
  };

  return (
    <div className="d-flex flex-direction-column h-100 overflow-hidden">
      <Row className="align-items-center px-15" justify="space-between">
        <Col>{/* <PrimaryLabel className={"fw-700 f-18"}>Claim Items</PrimaryLabel> */}</Col>
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              <Button onClick={handleAddNew()}>Add New Item</Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        <div className="px-15">
          {items.map((row, index) => (
            <LADClaimsItemCard
              itemDetails={row}
              key={row.itemSeq}
              index={index}
              editMode={Boolean(row.editMode)}
              setEditMode={setEditMode}
              handleCancel={handleCancel}
              handleSubmit={handleSubmit}
              handleDelete={handleDelete}
              handleNewProductModal={handleNewProductModal}
              shouldUpdateClaimantValueFromItemModal
            />
          ))}
        </div>
      </div>
      <AddProductFullModal
        addressBookModal={addProductModal && addProductModalIndex !== false}
        onSelectAddressBook={onSelectAddressBook}
        handleAddressBookModalClose={handleAddProductModalClose}
      />
    </div>
  );
};

export default CreateLADItems;
